import { Injectable } from '@angular/core';

import { PlainTextService } from '../../../Common/PageBuilder/services/plain-text.service';
import { BlockModel } from '../../../Common/PageBuilder/models/block.model';
import { VideoDisplayElementModel } from '../../../Common/PageBuilder/models/video-display-element.model';

import { WireBlockTypeEnum } from '../enums/wire-block-type.enum';
import { WireModel } from '../models/wire.model';
import { ContactDisplayElementModel } from '../models/contact-display-element.model';
import { SocialLinkDisplayElementModel } from '../models/social-link-display-element.model';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';


@Injectable()
export class WirePlainTextService extends PlainTextService {
    ignoreBlockTypes: WireBlockTypeEnum[] = [
        WireBlockTypeEnum.companyAddress,
        WireBlockTypeEnum.companyLogo,
        WireBlockTypeEnum.companyBio,
        WireBlockTypeEnum.companyAddress,
        WireBlockTypeEnum.companyAddress,
    ];

    constructor(protected localizationService: LocalizationService) {
        super(localizationService);
    }

    generateBodyPlainText(blocks: BlockModel[]): string {
        const bodyBlocks = blocks.filter(x => !this.ignoreBlockTypes.includes(x.type.key as WireBlockTypeEnum));
        let bodyText = '';
        bodyBlocks.forEach(block => {
            let newBlockText = '';
            switch (block.type.key) {
                case WireBlockTypeEnum.text:
                    newBlockText = this.generatePlainTextFromTextBlock(block);
                    break;
                case WireBlockTypeEnum.image:
                    newBlockText = this.generatePlainTextFromImageBlock(block);
                    break;
                case WireBlockTypeEnum.video:
                    newBlockText = this.generatePlainTextFromVideoBlock(block);
                    break;
                case WireBlockTypeEnum.contact:
                    newBlockText = this.generatePlainTextFromContactBlock(block);
                    break;
                case WireBlockTypeEnum.links:
                    newBlockText = this.generatePlainTextFromLinksBlock(block);
                    break;
            }
            if (newBlockText) {
                bodyText += newBlockText + '\n';
            }
        });

        return bodyText;
    }

    generatePlainTextFromVideoBlock(block: BlockModel): string {
        const displayElement = (block.displayElement as VideoDisplayElementModel);
        const caption = displayElement.caption;
        const url = displayElement.url;
        let videoText = '';

        if (url || caption) {
            videoText += '\n';
        }
        if (caption) {
            videoText += `${caption}`;
        }
        if (url) {
            videoText += ` (${url})`;
        }

        return videoText;
    }


    generatePlainTextFromContactBlock(block: BlockModel): string {
        const contact = (block.displayElement as ContactDisplayElementModel)?.contact;
        let contactText = '';

        if (contact) {
            if (contact.name) {
                contactText += `\nName: ${contact.name}`;
            }
            if (contact.email) {
                contactText += `\nEmail: ${contact.email}`;
            }
            if (contact.title) {
                contactText += `\nTitle: ${contact.title}`;
            }
            if (contact.primaryPhone) {
                contactText += `\nPrimary Phone: ${contact.primaryPhone}`;
            }
            if (contact.secondaryPhone) {
                contactText += `\nSecondary Phone: ${contact.secondaryPhone}`;
            }
        }
        return contactText;
    }


    generatePlainTextFromLinksBlock(block: BlockModel): string {
        const socialLinks = (block.displayElement as SocialLinkDisplayElementModel).socialLinks;
        let socialLinksText = '';

        if (socialLinks?.length) {
            for (const socialLink of socialLinks) {
                if (socialLink.linkType) {
                    socialLinksText += `\n${socialLink.linkType}`;
                }
                if (socialLink.text) {
                    socialLinksText += `\n${socialLink.text}`;
                }
                if (socialLink.url) {
                    socialLinksText += `\n(${socialLink.url})`;
                }
            }
        }

        return socialLinksText;
    }
}
